/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Typography, Button, Row, Col, Breadcrumb, Tooltip, Modal, Spin, Space, Select, Segmented, Input, Empty, Badge, Tag } from 'antd';
import * as AntDIcons from '@ant-design/icons';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';

const { Text } = Typography;
const { Option } = Select;

export function BStudentDiagnosticSubjects() {
   const navigate = useNavigate();

   const search = window.location.search;
   const query = new URLSearchParams(search);
   const diagnosticType = query.get('type');

   const [user_id] = useState(Utils.getCurrentUserInfo(Enums.UserInfo.id));
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   // const user_full_name = Utils.getCurrentUserInfo(Enums.UserInfo.fullname);

   const [subjectList, setSubjectList] = useState([]);

   useEffect(() => {
      Utils.verifyJwt();

      getSubjects(user_id);

   }, [diagnosticType]);

   const getSubjects = (userid) => {
      axios.get(`${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/subjectgroup?t=${diagnosticType}&sid=${user_id}`).then((response) => {
         if (response.data) {
            const data = response.data;
            var subjects = [];
            data.map((item) => {
               let obj = { 'value': item.id, 'name': item.subject_group, 'current': item.current, 'past': item.past }
               subjects.push(obj);
            });

            setSubjectList(subjects);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   // function colorize() {
   //    var r = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       g = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       b = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2);
   //    return '#' + r + g + b;
   // }

   const itemSubjectClick = (subject, subjectname) => {
      navigate(`/bdiagnostic/student?t=${diagnosticType}&s=${subject}&sn=${subjectname}`);
   }

   return (
      <>
         <NoticeBoardSlide />
         <div className="dashboard-area-all">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <Breadcrumb separator=">" style={{ paddingBottom: '15px' }}>
                     <Breadcrumb.Item>
                        <Link to="/home">Home</Link>
                     </Breadcrumb.Item>
                     <Breadcrumb.Item>Brainee LMS</Breadcrumb.Item>
                     <Breadcrumb.Item>{diagnosticType === 'pre' ? '(Pre) ' : '(Post) '}Diagnostic Assessment</Breadcrumb.Item>
                  </Breadcrumb>
               </div>
               {
                  subjectList.length > 0
                     ?
                     <div className="ag-format-container">
                        <div className="ag-courses_box">
                           {
                              // !questionTypeModalVisible &&

                              subjectList.map((subject, i) => {
                                 var color = Utils.colorize();

                                 return (
                                    <>
                                       <div className="ag-courses_item">
                                          <a href="#" className="ag-courses-item_link">
                                             <div className="ag-courses-item_bg" style={{ backgroundColor: color }} onClick={() => itemSubjectClick(subject.value, subject.name)}></div>
                                             <div className="ag-courses-item_title" onClick={() => itemSubjectClick(subject.value, subject.name)}>
                                                <Tooltip placement="top" title={subject.name}>
                                                   {subject.name}
                                                </Tooltip>
                                                <div className="ag-courses-item_date" style={{ width: "100%", justifyContent: "left", display: "flex", flexWrap: "wrap", gap: "15px", paddingTop: "20px" }}>
                                                   <Badge count={subject.current} style={{ backgroundColor: "green" }} overflowCount={999}>
                                                      <Tag color="green">Current</Tag>
                                                   </Badge>
                                                   <Badge count={subject.past} style={{ backgroundColor: "gray" }} overflowCount={999}>
                                                      <Tag color="gray">Past</Tag>
                                                   </Badge>
                                                </div>
                                             </div>
                                          </a>
                                       </div>
                                    </>
                                 )
                              })
                           }
                        </div>
                     </div>
                     :
                     <div className='center-empty-space'>
                        <Empty image="../../images/brainee_mascot.png" description="No records found." />
                     </div>
               }

            </div>
         </div>
      </>
   )
}